import { BaseEnvironmentPatterns } from './../../../environment/patterns/BaseEnvironmentPatterns';
/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 03.09.2014
 *   Time: 15:51
 */



export class ConcreteEnvironmentPatterns extends BaseEnvironmentPatterns {
    protected _branchesConfigPathPattern: string;
    protected _dataCookiePathPattern: string;
    protected _refCountURLPattern: string;
    protected _languagePropertiesPathPattern: string;
    protected _cldrConfigPathPattern: string;
    protected _audiosFolderPathPattern: string;
    protected _fontsSWFURLPattern: string;
    protected _fontsSWFURLPatternVersioned: string;
    protected _itemSWFURLPattern: string;
    protected _itemXMLURLPattern: string;
    protected _abTestConfigPathPattern: string;
    protected _abTestTrackPathPattern: string;
    protected _abTestDisplayPathPattern: string;
    protected _shopPathPattern: string;

    public get branchesConfigPathPattern(): string {
        return this._branchesConfigPathPattern;
    }

    public get dataCookiePathPattern(): string {
        return this._dataCookiePathPattern;
    }

    public get refCountURLPattern(): string {
        return this._refCountURLPattern;
    }

    public get languagePropertiesPathPattern(): string {
        return this._languagePropertiesPathPattern;
    }

    public get cldrConfigPathPattern(): string {
        return this._cldrConfigPathPattern;
    }

    public get fontsSWFURLPattern(): string {
        return this._fontsSWFURLPattern;
    }

    public get fontsSWFURLPatternVersioned(): string {
        return this._fontsSWFURLPatternVersioned;
    }

    public get itemSWFURLPattern(): string {
        return this._itemSWFURLPattern;
    }

    public get itemXMLURLPattern(): string {
        return this._itemXMLURLPattern;
    }

    public get abTestConfigPathPattern(): string {
        return this._abTestConfigPathPattern;
    }

    public get abTestTrackPathPattern(): string {
        return this._abTestTrackPathPattern;
    }

    public get abTestDisplayPathPattern(): string {
        return this._abTestDisplayPathPattern;
    }

    public get audiosFolderPathPattern(): string {
        return this._audiosFolderPathPattern;
    }

    public get shopPathPattern(): string {
        return this._shopPathPattern;
    }
}
